import { HashMap } from '@ngneat/transloco';
import { buildNotificationTranslationId, DateParams } from '@platform-frontend/transloco';
import { TranslationId } from '@platform-frontend/util';

const buildTranslationId: (key: string, params?: HashMap) => TranslationId = (key: string, params?: HashMap) => buildNotificationTranslationId(key, params);

// Account migration
export const MSG_ACCOUNT_MIGRATION_FROM_NOW = (vendorName: string): TranslationId =>
  buildTranslationId('accountMigration.fromNow', { vendorName, id: 'ac422924-6516-406e-9c8a-a7705fcaa4ba' });
export const MSG_ACCOUNT_MIGRATION_WITH_LAUNCH_DATE = (vendorName: string, launchDate: DateParams): TranslationId =>
  buildTranslationId('accountMigration.withLaunchDate', { vendorName, launchDate, id: 'b7cf17b6-391a-4397-a0d9-c57de782d153' });
export const MSG_ACCOUNT_MIGRATION_NVV_FROM_NOW = buildTranslationId('accountMigration.nvv.fromNow', { id: 'df2711a1-2d14-4810-ad65-3bfd42db1e6b' });
export const MSG_ACCOUNT_MIGRATION_NVV_WITH_LAUNCH_DATE = (launchDate: DateParams): TranslationId =>
  buildTranslationId('accountMigration.nvv.withLaunchDate', { launchDate, id: 'cc967c81-ed37-414b-8f7c-c5622d20c44b' });
